import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { Control as Select } from 'commons/js/ui/Select'
import { required } from 'commons/js/util/validators'
import { Copy } from '@elparking/components'

import messages from './messages'

function mapProvinceOptions (provinces) {
  return provinces.map((province) => ({
      province,
      value: province.id.toString(),
      label: province.name,
  }))
}

const SelectProvinceField = ({ intl, provinces, ...restProps }) => {
    return (
        <Select
          showLabel
          placeholder={intl.formatMessage(messages.placeholder)}
          label={intl.formatMessage(messages.province)}
          model='.provinceId'
          disabled={!provinces || !provinces.length}
          options={mapProvinceOptions(provinces)}
          clearable={false}
          clearRenderer={() => null}
          validators={{ required: required() }}
          renderOption={({ label }) => <Copy padding='0' fontWeight='regular' color='gray' fontSize='small'>{label.toString()}</Copy>}
          errorMessages={{
            required: intl.formatMessage(messages.requiredProvince),
          }}
          {...restProps}
        />
    )
}

SelectProvinceField.propTypes = {
  intl: PropTypes.object,
  provinces: PropTypes.array,
}

export default injectIntl(SelectProvinceField)
